<!-- Loading Overlay -->
<app-loading-overlay [show]="isDownloading" message="Downloading PDF..."></app-loading-overlay>

<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Purchase Orders" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <!-- Header -->
      <div class="card-header border-0">
        <div class="row align-items-center gy-3">
          <div class="col-sm">
            <h5 class="card-title mb-0">Purchase Orders</h5>
          </div>
          <div class="col-sm-auto">
            <div class="d-flex gap-1 flex-wrap">
              <button type="button" class="btn btn-success add-btn" (click)="toggleForm()">
                <i [class]="showForm ? 'ri-close-line' : 'ri-add-line'" class="align-bottom me-1"></i> 
                {{ showForm ? 'Cancel' : 'Create Purchase Order' }}
              </button>
              <button type="button" class="btn btn-info" (click)="loadPurchaseOrders()">
                <i class="ri-refresh-line align-bottom me-1"></i> Refresh
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Inline Form (Show/Hide) -->
      <div class="card-body border-bottom" *ngIf="showForm" id="purchaseOrderForm">
        <div class="bg-light p-4 rounded">
          <h5 class="mb-3">
            <i class="ri-file-list-3-line align-middle me-1"></i>
            {{ isEditMode ? 'Edit Purchase Order' : 'Create New Purchase Order' }}
          </h5>

          <form [formGroup]="purchaseOrderForm" (ngSubmit)="savePurchaseOrder()">
            <div class="row g-3">
              <!-- Demand Selection -->
              <div class="col-lg-6">
                <label for="demand_id" class="form-label">Select Demand <span class="text-danger">*</span></label>
                <select class="form-control" id="demand_id" formControlName="demand_id"
                        [class.is-invalid]="submitted && f['demand_id'].errors">
                  <option value="">Select Demand</option>
                  <option *ngFor="let demand of demands" [value]="demand.id">
                    {{ demand.demandNumber }} - {{ demand.purpose }} ({{ demand.priority }})
                  </option>
                </select>
                <div *ngIf="submitted && f['demand_id'].errors" class="invalid-feedback">
                  <span *ngIf="f['demand_id'].errors['required']">Demand selection is required</span>
                </div>
              </div>

              <!-- Demand Details (Read-only) -->
              <div class="col-lg-12" *ngIf="selectedDemand">
                <hr class="my-3">
                <h6 class="mb-3"><i class="ri-file-list-3-line me-1"></i> Demand Details</h6>
                
                <div class="row g-3">
                  <!-- Demand Info -->
                  <div class="col-md-3">
                    <label class="form-label text-muted small">Demand Number</label>
                    <input type="text" class="form-control bg-light" [value]="selectedDemand.demandNumber" readonly>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label text-muted small">Required By Date</label>
                    <input type="text" class="form-control bg-light" [value]="selectedDemand.requiredByDate | date:'mediumDate'" readonly>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label text-muted small">Priority</label>
                    <input type="text" class="form-control bg-light" [value]="selectedDemand.priority" readonly>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label text-muted small">Status</label>
                    <input type="text" class="form-control bg-light" [value]="selectedDemand.status" readonly>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label text-muted small">Purpose</label>
                    <input type="text" class="form-control bg-light" [value]="selectedDemand.purpose" readonly>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label text-muted small">Organizational Unit</label>
                    <input type="text" class="form-control bg-light" [value]="selectedDemand.organizationalUnit?.name" readonly>
                  </div>
                  <div class="col-md-12" *ngIf="selectedDemand.remarks">
                    <label class="form-label text-muted small">Demand Remarks</label>
                    <textarea class="form-control bg-light" [value]="selectedDemand.remarks" readonly rows="2"></textarea>
                  </div>
                </div>

                <!-- Items Section -->
                <div class="mt-4" *ngIf="selectedDemand.items && selectedDemand.items.length > 0">
                  <h6 class="mb-3"><i class="ri-shopping-cart-line me-1"></i> Items</h6>
                  
                  <div class="table-responsive">
                    <table class="table table-bordered table-sm">
                      <thead class="table-light">
                        <tr>
                          <th>#</th>
                          <th>Supplier</th>
                          <th>Item</th>
                          <th>Qty</th>
                          <th>Unit</th>
                          <th>Unit Price</th>
                          <th>GST %</th>
                          <th class="text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of selectedDemand.items; let i = index">
                          <td>{{ i + 1 }}</td>
                          <td>
                            <span *ngIf="item.supplier">{{ item.supplier.name }}</span>
                            <span *ngIf="!item.supplier" class="text-muted">Not assigned</span>
                          </td>
                          <td>
                            {{ item.item?.name }}
                            <small class="text-muted d-block" *ngIf="item.specifications">{{ item.specifications }}</small>
                          </td>
                          <td>{{ item.requestedQuantity }}</td>
                          <td>{{ item.item?.unit?.symbol }}</td>
                          <td class="text-end">₹{{ item.price_history?.price || 0 | number: '1.2-2' }}</td>
                          <td class="text-center">{{ item.item?.gstRate || 0 }}%</td>
                          <td class="text-end">
                            <strong>₹{{ (item.requestedQuantity * (item.price_history?.price || 0)) + ((item.requestedQuantity * (item.price_history?.price || 0)) * (item.item?.gstRate || 0) / 100) | number: '1.2-2' }}</strong>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot class="table-light">
                        <tr>
                          <td colspan="7" class="text-end"><strong>Subtotal:</strong></td>
                          <td class="text-end"><strong>₹{{ calculateSubtotal(selectedDemand) | number: '1.2-2' }}</strong></td>
                        </tr>
                        <tr>
                          <td colspan="7" class="text-end"><strong>Tax Amount:</strong></td>
                          <td class="text-end"><strong>₹{{ calculateTaxAmount(selectedDemand) | number: '1.2-2' }}</strong></td>
                        </tr>
                        <tr class="table-success">
                          <td colspan="7" class="text-end"><strong>Grand Total:</strong></td>
                          <td class="text-end"><strong class="fs-5">₹{{ calculateGrandTotal(selectedDemand) | number: '1.2-2' }}</strong></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Terms and Conditions -->
              <div class="col-lg-12">
                <hr class="my-3">
                <div class="row g-3">
                  <div class="col-lg-6">
                    <label for="terms_and_conditions" class="form-label">Terms & Conditions</label>
                    <textarea class="form-control" id="terms_and_conditions" formControlName="terms_and_conditions" 
                              rows="3" placeholder="Enter terms and conditions"></textarea>
                  </div>
                  <div class="col-lg-6">
                    <label for="remarks" class="form-label">Remarks</label>
                    <textarea class="form-control" id="remarks" formControlName="remarks" 
                              rows="3" placeholder="Enter remarks"></textarea>
                  </div>
                </div>
              </div>

              <!-- Form Actions -->
              <div class="col-lg-12">
                <hr class="my-3">
                <div class="d-flex gap-2 justify-content-end">
                  <button type="button" class="btn btn-light" (click)="cancelForm()">
                    <i class="ri-close-line align-bottom me-1"></i> Cancel
                  </button>
                  <button type="submit" class="btn btn-success">
                    <i class="ri-save-line align-bottom me-1"></i> 
                    {{ isEditMode ? 'Update' : 'Save' }} Purchase Order
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Filters -->
      <div class="card-body border border-dashed border-end-0 border-start-0">
        <div class="row g-3">
          <div class="col-xxl-5 col-sm-6">
            <div class="search-box">
              <input type="text" name="searchTerm" class="form-control" placeholder="Search by PO Number, Supplier, Status..." 
                     [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}" 
                     (keyup.enter)="performSearch()" (blur)="performSearch()">
              <i class="ri-search-line search-icon"></i>
            </div>
          </div>
          
          <div class="col-xxl-3 col-sm-4">
            <select class="form-control" name="statusFilter" [(ngModel)]="statusFilter" 
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="filterByStatus()">
              <option value="">All Status</option>
              <option value="Approved">Approved</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card-body pt-0">
        <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div *ngIf="!isLoading" class="table-responsive table-card mb-0">
          <table class="table align-middle table-nowrap">
            <thead class="table-light">
              <tr>
                <th>PO #</th>
                <th>Supplier</th>
                <th>PO Date</th>
                <th>Status</th>
                <th>Total Amount</th>
                <th>Tax Amount</th>
                <th>Grand Total</th>
                <th>Items</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="purchaseOrders.length === 0">
                <td colspan="9" class="text-center py-4">
                  <div class="text-muted">
                    <i class="ri-inbox-line fs-1"></i>
                    <p class="mt-2">No purchase orders found</p>
                  </div>
                </td>
              </tr>
              
              <tr *ngFor="let order of purchaseOrders; let i = index">
                <td><strong>{{ order.poNumber }}</strong></td>
                <td>{{ order?.supplier?.name }}</td>
                <td>{{ order.poDate | date: 'mediumDate' }}</td>
                <td>
                  <span class="badge text-uppercase" [ngClass]="getStatusClass(order.status)">
                    {{ order.status }}
                  </span>
                </td>
                <td>₹{{ order.totalAmount | number: '1.2-2' }}</td>
                <td>₹{{ order.taxAmount | number: '1.2-2' }}</td>
                <td><strong>₹{{ order.grandTotal | number: '1.2-2' }}</strong></td>
                <td>
                  <span class="badge bg-primary">{{ order.items?.length || 0 }} items</span>
                </td>
                <td>
                  <div class="d-flex gap-2">
                    <button class="btn btn-sm btn-secondary" 
                            (click)="viewPurchaseOrder(order)" 
                            ngbTooltip="View Details">
                      <i class="ri-eye-line"></i>
                    </button>
                    <button class="btn btn-sm btn-info" 
                            (click)="downloadPurchaseOrder(order.id || order._id)" 
                            [disabled]="isDownloading"
                            ngbTooltip="Download PDF">
                      <i class="ri-download-2-line"></i>
                    </button>
                    <button class="btn btn-sm btn-primary" 
                            (click)="sendEmailToSupplier(order.id || order._id)" 
                            ngbTooltip="Send Email to Supplier">
                      <i class="ri-mail-send-line"></i>
                    </button>
                    <button class="btn btn-sm btn-warning" 
                            (click)="cancelPurchaseOrder(order.id || order._id)" 
                            *ngIf="order.status !== 'Cancelled' && order.status !== 'Received'"
                            ngbTooltip="Cancel Purchase Order">
                      <i class="ri-close-circle-line"></i>
                    </button>
                    <button class="btn btn-sm btn-danger" 
                            (click)="deletePurchaseOrder(order.id || order._id)" 
                            *ngIf="canEditPurchaseOrder(order)"
                            [ngbTooltip]="canEditPurchaseOrder(order) ? 'Delete' : 'Can only delete Draft or Pending orders'">
                      <i class="ri-delete-bin-fill"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row justify-content-md-between align-items-md-center mt-3" *ngIf="purchaseOrders.length > 0">
          <div class="col col-sm-6">
            <div class="dataTables_info mb-2">
              Showing {{ paginationService.startIndex }} to {{ paginationService.endIndex }} of {{ allPurchaseOrders.length }} entries
            </div>
          </div>
          <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
              <ngb-pagination [collectionSize]="allPurchaseOrders.length" 
                              [(page)]="paginationService.page" 
                              [pageSize]="paginationService.pageSize" 
                              (pageChange)="changePage()">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
